import React from "react";
import { Container, Row, Col, Nav, Form } from "react-bootstrap";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import logo from '../image/pt_bg.png';
import classes from './footer.module.css';
import SiteButton from "./Ui/button/siteButton";

const Footer = () => {
    return (
        <footer>
            <Container>
                <Row>
                    <Col>
                        <div className={classes.footer_block}>
                            <Nav className="flex-column">
                                <Nav.Link to="/" className={classes.footerLink}>О компании</Nav.Link>
                                <Nav.Link to="#" className={classes.footerLink}>Продукты и решения</Nav.Link>
                            </Nav>
                            <img src={logo} />
                            <div className={classes.text_copyright}>
                                <p>2023<span>ООО "ПИЛОТ ТЕЛЕКОМ"</span></p>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className={classes.footerForm}>
                            <h3 className={classes.formTitle}>Запросить подробную информацию или задать вопрос?
        Заполните форму заявки, наш менеджер свяжется с вами!</h3>
                            <Form>
                                <FloatingLabel
                                    controlId="floatingInput"
                                    label="Email"
                                    className="mb-3"
                                >
                                <Form.Control type="email" placeholder="Email" />
                                </FloatingLabel>
                                    <FloatingLabel
                                        controlId="floatingInput"
                                        label="Имя"
                                        className="mb-3"
                                    >
                                    <Form.Control type="text" placeholder="Имя" />
                                </FloatingLabel>
                                <SiteButton variant="primary" type="submit">
                                    Отправить
                                </SiteButton>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer;